
<template>
    <div>
        <scroll-list @onPullingDown="onPullingDown" ref="listScroll">
            <section>
                <div class="title" v-if="!INWECHAT">
                    <div class="title-left" @click="backEvent">

                    </div>
                </div>
                <div v-if="isSelf">
                    <div :class="!already ? 'couponContent pending' :'couponContent ending'">
                        <div class="couponContent-title">
                            {{actName || '未知奖励'}}
                        </div>
                        <div class="couponContent-footer">
                            邀请
                            <span>{{num}}</span>位好友，立即领取
                        </div>
                    </div>
                    <!-- 未达标 -->
                    <div class="couponContent-button" v-if="!hasBagin && !already" @click="check">
                        分享给好友
                    </div>
                    <!-- 可领取 -->
                    <div class="couponContent-button" v-if="!already && hasBagin" @click="receiveAward">
                        立即领取
                    </div>
                    <!-- 夷陵区 -->
                    <div class="couponContent-button" v-if="hasBagin && already" @click="alreadyHas">
                        已领取
                    </div>
                    <div class="couponContent-text">
                        <span>!</span> 领取现金红包需绑定微信账号，领取到“零钱”
                    </div>
                    <div class="userInfo">
                        <div v-for="index in num" :key="index" class="item">
                            <div class="item-top">
                                <img :src="listData[index-1] ? listData[index-1].headimgurl : 'https://source.96299.com.cn/app/icon/userLoad.png'">
                            </div>
                            <div class="item-bottom">
                                {{listData[index-1]?listData[index-1].nickname : "待助力"}}
                            </div>
                        </div>
                    </div>
                    <div class="userList">
                        <div id="parent" class="parent">
                            <div id="child1" class="child">
                                <div v-for="(item,index) in scrollList" :key="index" class="child-item">
                                    <div>
                                        <img id="mockImg" :src="item.avatar" alt="">
                                    </div>
                                    <div>
                                        {{item.nickname}}
                                    </div>
                                    <div>
                                        领取了
                                    </div>
                                    <div>
                                        {{item.attr_name}}
                                    </div>
                                </div>
                            </div>
                            <div id="child2" class="child"></div>
                        </div>
                    </div>
                </div>
                <div v-else-if="isUser && already">
                    <div class="couponContent helper">
                        <div class="couponContent-helperTitle">
                            <span>
                                领取成功
                            </span>

                            <p>
                                {{actName || '¥0.0'}}
                            </p>
                        </div>
                        <div class="couponContent-footer">
                            {{describe}}
                        </div>
                    </div>

                    <a class="couponContent-button" href="https://universelink.yftepay.com/" v-if="already && !checkAndroidStatus">
                        去京福APP使用
                        <!-- <a id="jumpApp" ">测试掉起app</a> -->
                    </a>
                    <div class="couponContent-button" @click="check" v-else-if="already && checkAndroidStatus">
                        去京福APP使用
                    </div>
                    <div class="couponContent-button" v-else @click="alreadyHas">
                        已领取
                    </div>
                </div>
                <div v-else-if="isRegister">
                    <div class="couponContent helper">
                        <div class="couponContent-title">
                            <span>
                                成功助力
                            </span>
                        </div>
                        <div class="couponContent-footer">
                            谢谢你的帮忙，也送你一个
                        </div>
                    </div>
                    <div class="register">
                        <div class="register-phone">
                            <input v-model="mobile" type="text" placeholder="请输入手机号领取">
                        </div>
                        <div class="register-code">
                            <input type="text" v-model="qrcode" placeholder="请输入验证码">
                            <span @click="sendCode">{{codeText}}</span>
                        </div>
                    </div>

                    <div class="couponContent-button" style="margin-top:22px" @click="registerClick">
                        立刻领取
                    </div>
                </div>
                <div v-else>
                    <div class="couponContent helper">
                        <div class="couponContent-title">
                            <span>
                                成功助力
                            </span>
                        </div>
                        <div class="couponContent-footer">
                            谢谢你的帮忙，也送你一个
                        </div>
                    </div>

                    <div class="couponContent-button" style="margin-top:22px" @click="registerClick">
                        立刻领取
                    </div>
                </div>

                <div class="activityRule">
                    <div class="activityRule-title">
                        活动规则
                    </div>
                    <ul>
                        <li> 1、活动玩法：京福APP用户参与活动，分享给好友，完成任务后获得消费券或现金红包奖励。</li>
                        <li>2、发起次数：每天均可参与活动，满足邀请好友人数即可领取奖励。 </li>
                        <li>3、使用规则：消费券仅可在京福APP“生活服务”中登录使用，红包获得后将直接存入微信“零钱”内</li>
                        <li>4、消费券可与其他同类型业务券叠加使用，缴费时卡券面值不能高于订单应付金额。</li>
                        <li>5、如有疑问请联系客服：010-64090199。</li>
                    </ul>

                </div>
                <div class="activityRule-instructions" v-if="!checkAndroidStatus">
                    *兑换项和活动均与设备生产商Apple Inc.无关
                </div>
            </section>
        </scroll-list>
    </div>
</template>

<script>
import {isAndroid} from "../../base/callClient/core/useragent.js";
import {ISHXTAPP, ISWECHAT} from "../../base/lib/index";
import {getClientAdapter} from "../../base/callClient";
import {
    doGetVerifyImageCode,
    doGetRecordList,
    doSendEquity,
    doActRegister,
    doGetCode
} from "./api";
export default {
    name: "couponActivity",
    data() {
        return {
            INWECHAT: false,
            mobile: "",
            isUser: false,
            isRegister: false,
            already: false,
            isSelf: true,
            num: "",
            shareCode: "",
            actName: "",
            listData: [],
            scrollList: [],
            code: "",
            userInfo: {},
            actUuid: "",
            checkAndroidStatus: false,
            hasBagin: false,
            token: "",
            qrcode: "",
            scroll: "",
            wxPlus: "",
            countdown: 60,
            codeText: "发送验证码",
            shareInfo: {},
            describe: "",
            unionid: ""
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.checkAndroid();
            if (ISWECHAT) {
                vm.INWECHAT = true;
                // 没有问号说明是助力后跳转
                if (window.location.href.indexOf("?") != -1) {
                    // 等于shareCode说明是从端内分享出来的链接，而不是点击助力后的链接
                    let shareCode = window.location.href
                        .split("shareCode=")[1]
                        .substring(0, 20);
                    localStorage.setItem("shareCode", shareCode);
                    localStorage.removeItem("wxCode");
                    setTimeout(function () {
                        vm.$router.push({
                            name: "compatibleWithPage",
                            params: {
                                // shareCode: pair[1]
                                shareCode
                            }
                        });
                    }, 500);

                    // }
                } else if (vm.$route.params.isRegister) {
                    // 未注册用户;
                    vm.isRegister = true;
                    vm.already = false;
                } else {
                    // 注册用户
                    vm.isUser = true;
                    if (vm.$route.params.shareInfo) {
                        vm.actName = vm.$route.params.shareInfo.attr_name;
                        vm.describe = vm.$route.params.shareInfo.describe;
                    }
                }
                if (vm.$route.params.hasRewards) {
                    vm.already = true;
                }
                vm.isSelf = false;
            } else if (ISHXTAPP) {
                // 端内查看一定是本人
                vm.isSelf = true;
                vm.getData();
                vm.getScrollList();
                vm.token = vm.$route.query.token;
                vm.shareCode = vm.$route.query.shareCode;
            } else {
                vm.$router.push("/nowechatpage");
            }
        });
    },
    methods: {
        onPullingDown(ref) {
            if (ISHXTAPP) {
                setTimeout(() => {
                    this.getData();
                    this.getScrollList();
                    ref.forceUpdate(false);
                }, 500);
            }
        },
        async registerClick() {
            this.$Indicator.open({
                spinnerType: "fading-circle"
            });
            let params = {
                wxCode: localStorage.getItem("wxCode"),
                mobile: this.mobile,
                share_code: localStorage.getItem("shareCode"),
                code: this.qrcode
            };
            let data = await doActRegister(params);
            if (!data.hasError) {
                this.$Toast({message: "领取成功！"});
                if (this.mobile && this.qrcode) {
                    this.isUser = true;
                }
                this.actName = data.info.attr_name;
                this.describe = data.info.describe;
                this.already = true;
            }
            this.$Indicator.close();
        },
        async sendCode() {
            this.$Indicator.open({
                spinnerType: "fading-circle"
            });
            if (this.countdown > 0 && this.countdown < 60) {
                return 1;
            }
            if (this.countdown == 60) {
                await doGetCode({
                    mobile: this.mobile
                });
                this.settime(this.countdown);
            }
            this.$Indicator.close();
        },
        settime(val) {
            let that = this;
            if (this.countdown == 0) {
                this.codeText = "获取验证码";
                this.countdown = 60;
            } else {
                this.codeText = "重新发送(" + this.countdown + ")";
                this.countdown--;
                setTimeout(function () {
                    that.settime(val);
                }, 1000);
            }
        },
        checkAndroid() {
            this.checkAndroidStatus = isAndroid();
        },
        backEvent() {
            api.closeWin();
        },
        alreadyHas() {
            return this.$Toast({message: "您已经领取过咯～"});
        },
        async getScrollList() {
            let data = await doGetRecordList({
                token: this.$route.query.token
                // token: "app_4290568fd3bd9d48c80cb2324aedb082_ygrMYPDf"
            });
            if (!data.hasError) {
                this.scrollList = data.list;
            }
        },
        async receiveAward() {
            if (!ISHXTAPP) {
                return this.check();
            }
            _hmt.push(["_trackEvent", "getBtnClick", "click", "领取按钮点击"]);
            let data = await doSendEquity({
                share_code: this.shareCode,
                token: this.token
            });
            if (!data.hasError) {
                this.already = true;
                this.hasBagin = true;
                this.$Toast({
                    message: "领取成功"
                });
            }
        },
        async getData() {
            this.$Indicator.open({
                spinnerType: "fading-circle"
            });
            let data = await doGetVerifyImageCode({
                act_uuid: this.$route.query.uuid,
                token: this.$route.query.token
            });
            if (!data.hasError) {
                // $api.setStorage("shareCode", data.info.attr_info.share_code);
                this.unionid = data.info.attr_info.unionid;
                this.num = data.info.actInfo.share_num;
                this.listData = data.info.recordDetail;
                this.shareCode = data.info.attr_info.share_code;
                this.actName = data.info.attr_info.attr_name;
                this.shareInfo = data.info.actInfo.share_info;
                if (this.listData.length > 0) {
                    this.hasBagin = true;
                }

                // 可领取
                if (data.info.attr_info.status == 3) {
                    this.hasBagin = true;
                    this.already = false;
                    // 已领取
                } else if (data.info.attr_info.status == 2) {
                    this.hasBagin = true;
                    this.already = true;
                    // 未达标
                } else if (data.info.attr_info.status == 1) {
                    this.already = false;
                    this.hasBagin = false;
                }
            }
            this.$Indicator.close();
        },
        async check() {
            // 判断端内端外
            if (ISHXTAPP) {
                this.getData();
                _hmt.push(["_trackEvent", "shareBtn", "click", "分享按钮点击"]);
                if (!this.unionid) {
                    return api.sendEvent({
                        name: "login"
                    });
                }
                // 端内 调用端的分享能力
                return api.openFrame({
                    name: "share",
                    url: "widget://html/wxShare/wxShare.html",
                    rect: {
                        x: 0,
                        y: 0,
                        w: api.winWidth,
                        h: api.winHeight
                    },
                    // 设置frame背景色，此处需要考虑frame会继承父类的背景色
                    bgColor: "rgba(0,0,0,0.6)",
                    pageParam: {
                        shareCode: this.shareCode,
                        shareInfo: this.shareInfo
                    }
                });
            } else {
                let h5CallClient = await getClientAdapter();
                h5CallClient.initAppConfig({
                    PROTOCOL: "hxtapp://"
                });
                h5CallClient({
                    action: "1"
                });
            }
        },
        initScroll() {
            var parent = document.getElementById("parent");
            var child1 = document.getElementById("child1");
            var child2 = document.getElementById("child2");
            child2.innerHTML = child1.innerHTML;
            setInterval(function () {
                if (parent.scrollTop >= child1.scrollHeight) {
                    parent.scrollTop = 0;
                } else {
                    parent.scrollTop++;
                }
            }, 100);
        }
    },
    updated() {
        this.initScroll();
    }
};
</script>
<style lang="scss" scoped>
#jumpApp {
    display: none;
}
img {
    border: none;
}

.body {
    width: 100%;
    box-sizing: border-box;
}
section {
    text-align: center;
    box-sizing: border-box;
    padding: 30px 15px;
    background: url(../../assets/image/coupon_bg.png) no-repeat;
    background-size: cover;
}

section .couponContent {
    width: 100%;
    height: 218px;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 50%;
    // background-size: 100%;
    position: relative;
    overflow: hidden;
    background-size: 100% 100%;
}
.pending {
    background: url(../../assets/image/activity_pending.png) no-repeat;
}
.ending {
    background: url(../../assets/image/activity_ending.png) no-repeat;
}
.helper {
    background: url(../../assets/image/activity_helper.png) no-repeat;
}

section .couponContent .couponContent-title {
    width: 65%;
    text-align: center;
    line-height: 25px;
    font-size: 28px;
    font-weight: bold;
    color: #f24207;
    position: absolute;
    top: 28%;
    left: 0;
    right: 0;
    margin: auto;
    word-wrap: break-word;
    line-height: 1;
}

section .couponContent .couponContent-footer {
    font-size: 18px;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 19%;
    margin: auto;
    color: rgba(253, 244, 227, 1);
    z-index: 1000;
}

section .couponContent-button {
    text-align: center;
    width: 226px;
    height: 58px;
    background: url(../../assets/image/button.png);
    background-size: cover;
    border-radius: 21px;
    margin-top: 4%;
    margin-left: 50%;
    transform: translateX(-50%);
    line-height: 50px;
    font-size: 22px;
    font-weight: bold;
    text-shadow: 3px 5px 5px rgba(252, 194, 0, 0.5);
    color: rgba(255, 255, 255, 1);
}

section .couponContent-text {
    font-size: 12px;
    margin-top: 11px;
    color: #ce631a;
}

section .couponContent-text span {
    width: 13px;
    height: 13px;
    border: solid 1px #ce631a;
    border-radius: 50%;
}

section .userInfo {
    box-sizing: border-box;
    width: 94%;
    background: rgba(255, 245, 228, 1);
    border-radius: 20px;
    margin-top: 36px;
    padding: 18px 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: 50%;
    transform: translateX(-50%);
}

section .userInfo .item {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 55px;
    height: 80px;
    margin: 0 6px;
    text-align: center;
}

section .userInfo .item .item-top {
    width: 40px;
    height: 40px;
    img {
        width: 100%;
        height: 100%;
    }
}

section .userInfo .item .item-bottom {
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.parent {
    width: 94%;
    max-height: 200px;
    margin: 30px auto auto auto;
    overflow-y: auto;
    color: #d28957;
    font-size: 14px;
    overflow: hidden;
    -overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
}
.parent::-webkit-scrollbar {
    display: none;
}

.child {
    height: auto;
}

.child .child-item {
    height: 50px;
    margin: 2px 0;
    line-height: 19px;
    display: flex;
    justify-content: space-between;
}

.child .child-item > div:nth-child(2) {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}
.child .child-item > div:nth-child(4) {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}
.child .child-item > div:nth-child(3) {
    text-align: right;
}

.child .child-item #mockImg {
    width: 20px;
    border-radius: 50%;
    margin-right: 14px;
}

.activityRule {
    width: 96%;
    /*height: 240px;*/
    background: #fff;
    border-radius: 20px;
    margin-top: 20px;
    margin-left: 50%;
    transform: translateX(-50%);
    text-align: center;
    box-sizing: border-box;
    padding: 16px 22px;
}

.activityRule .activityRule-title {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 18px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-bottom: solid 1px rgba(210, 137, 87, 1);
    margin-left: 50%;
    transform: translateX(-50%);
}

.activityRule ul {
    width: 100%;
    // height: 144px;
    color: #666;
    font-size: 12px;
    text-align: left;
    margin-top: 18px;
    box-sizing: border-box;
    margin-left: 50%;
    transform: translateX(-50%);
}

.activityRule ul li {
    box-sizing: border-box;
    padding: 2px 0;
}

.activityRule ul li:nth-last-of-type(1) {
    padding-bottom: 0;
}

.activityRule-instructions {
    padding: 8px 0;
    font-size: 12px;
    font-weight: 400;
    color: #d28957;
}

.title {
    box-sizing: border-box;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: whitesmoke;
    // position: sticky;
    top: 20px;
    z-index: 10;
}
.title > div:nth-child(2) {
    flex: 1;
}
.title > div:nth-child(3) {
    flex: 1;
}

.title .title-left {
    // width: 24px;
    flex: 1;
    height: 23px;
    background: url(../../assets/image/backwhite.png) no-repeat left;
    background-size: 10px;
}
.couponContent-helperTitle {
    text-align: center;
    line-height: 25px;
    font-weight: bold;
    position: absolute;
    top: 36px;
    left: 0;
    right: 0;
    margin: auto;
    word-wrap: break-word;
    line-height: 1;
    span {
        font-size: 18px;
        font-weight: 500;
        color: rgba(242, 66, 7, 1);
    }
    p {
        font-size: 36px;
        font-weight: bold;
        color: rgba(242, 66, 7, 1);
        margin-top: 22px;
    }
}
.register {
    width: 100%;
    box-sizing: border-box;
    margin-top: 50px;
    padding: 0 34px;
    input {
        background: white;
        height: 40px;
        border: none;
        outline: none;
    }
    input::-webkit-input-placeholder {
        padding-left: 20px;
    }
    .register-phone {
        input {
            width: 100%;
            text-indent: 20px;
        }
    }
    .register-code {
        text-align: left;
        margin-top: 12px;
        input {
            width: 56%;
            text-indent: 20px;
        }
        span {
            width: 35%;
            margin-left: 5%;
            color: #d0661b;
        }
    }
}
</style>
